var map = {
	"./DELTA_logo2.jpg": 1088,
	"./ERSTE_logo2.jpg": 1089,
	"./ILIRIK_logo2.jpg": 1090,
	"./M&V_logo2.jpg": 1091,
	"./MMNT_logo2.jpg": 1092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1087;